import React, { Fragment } from 'react';

import PagesError500Content from '../../example-components/PagesError500/PagesError500Content';
export default function PagesError500() {
  return (
    <Fragment>
      <PagesError500Content />
    </Fragment>
  );
}
